import { ref, defineComponent, watch } from "vue";
import RadioButton from 'primevue/radiobutton';
import { postAsk } from "@/assets/utils/utils";
import { make_ciphertext } from "@/assets/assist";
import swal from 'sweetalert';
export default defineComponent({
  name: "IndexPage",
  components: {
    RadioButton
  },

  setup() {
    let loginType = ref(1);
    let placeholder = ref('手机号码');
    let username = ref(null);
    let password = ref(null); // eslint-disable-next-line

    watch(loginType, (newVal, oldVal) => {
      if (newVal === 1) placeholder.value = '手机号码';else if (newVal === 2) placeholder.value = '电子邮箱';else if (newVal === 3) placeholder.value = 'ＱＱ号码';
    });

    function input_key_down_handler(event) {
      if (event.keyCode === 13) {
        login_button_clicked();
      }
    }

    function login_button_clicked() {
      if (!username.value) {
        swal('错误', '请输入' + placeholder.value + '!', 'error');
        return;
      }

      if (!password.value) {
        swal('错误', '请输入密码!', 'error');
        return;
      }

      var param = new FormData();
      param.append('username', make_ciphertext(username.value));
      param.append('password', make_ciphertext(password.value));
      param.append('login_type', loginType.value);
      postAsk('/oth_api/tenant_login', param).then(response => {
        let res = response.data;
        console.log(res);

        if (res.res === 1) {
          swal('提示', res.desc, 'success');
          let access_token = res['access_token'];
          let token_type = res['token_type'];
          localStorage.setItem('access_token', access_token);
          localStorage.setItem('token_type', token_type);
          document.location.href = 'major.html';
        } else {
          swal('错误', res.desc, 'error');
          username.value = null;
          password.value = null;
        }
      });
    }

    return {
      loginType,
      placeholder,
      username,
      password,
      input_key_down_handler,
      login_button_clicked
    };
  }

});